<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add SCORM
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small @click="closePanel" color="primary">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.title"
              v-model="doc.title"
              label="Title"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter title</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-textarea
              v-model="doc.description"
              label="Description"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter a description</span>
                </v-tooltip>
              </template>
            </v-textarea>
             <!--<v-file-input
                label="SCORM Package"
                v-model="doc.package"
                filled
                prepend-icon="mdi-file"
                ref="package"
                v-on:change="handleFileUpload()"
              >
              </v-file-input>-->
              
            <drop-zone
              id="dropzone"
              :type="type"
              :accepted="accepted"
              :maxFilesize="maxFileSize"
              class="mt-5 dropzone-container"
            ></drop-zone>
            <label v-if="messages.file"
            :error-messages="messages.file" class="v-messages theme--light error--text">{{ messages.file[0] }}</label>
            <p class="block text-left mt-4 caption">
              Max upload filesize: 500MB <br />
              Accepted file formats: Zip
            </p>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68">
      <v-flex text-right>
        <v-btn v-if="!s3Uploading || !loading" :color="$store.getters.partner ? 'primary': 'grey300'"  @click="closePanel">Cancel</v-btn>
        &nbsp;
        <v-btn v-if="s3Uploading || loading" color="primary" class="ml-2" loading></v-btn>
        <v-btn v-else :color="$store.getters.partner ? 'primary': 'dark-blue'" :class="['ml-2', $store.getters.partner ? '' : 'add-course-button']" @click="addDocument">Add SCORM</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import DropZone from "@/components/global/Dropzone";
export default {
  name: "AddDocument",
  components: {
    DropZone
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data: () => ({
    doc: {},
    package:'',
    messages: {},
    type: "scorm",
    maxFileSize: 500,
    accepted:
      "application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip",
    loading: false,
    successMessage: "SCORM package has been uploaded successfully.",
    errorMessage:
      "Oops, something went wrong! Please check information is correct.",
    s3ErrorMessage: "File upload error",
    fileUploaded:false
  }),
  computed: {
    s3Uploading() {
    return this.$store.getters.s3Uploading
    /*alert(this.$store.getters.s3Uploading);
    if(this.$store.getters.s3Uploading) {
      this.fileUploaded=true;
      return this.$store.getters.s3Uploading;
    } else {
      if(this.fileUploaded) {
        setTimeout(function(){ this.setLoading(this.$store.getters.s3Uploading)
        }, 2000);
      } else {
        this.setLoading(this.$store.getters.s3Uploading);
      }
    }*/
      /*if(this.$store.getters.s3Uploading) {
        this.fileUploaded=true;
        //if(this.fileUploaded) {
          this.loading = true;
        //}
        alert('he');
      }
      else { 
      if(this.fileUploaded)
        return setTimeout(function(){alert('hh'); this.loading=false; }, 2000);
      else {
      this.loading = false;
      }
       //return this.$store.getters.s3Uploading; 
      }*/
    }
  },
  mounted() {
    //this.awss3.params.type = "scorm";
    //this.awss3.params.course_id = this.id;
    this.doc.courseId = this.id;
  },
  methods: {
    closePanel() {
      this.$emit("closePanel", {});
    },
    handleFileUpload(){
        this.package = this.doc.package;
    },
    addDocument() {
      this.loading = true;
      courseAPI
        .addScorm(
          this.doc,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then(resp => {
          this.closePanel();
          this.$store.dispatch("addCourseMaterials", resp.data.data);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
